module.exports = `
    .container {
        grid-template-columns: 10%
    }

    .Button__Submit {
        .syn-dev-ui-button-focus-container  {
            padding: 3px 16px;
        }
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    [class^='syn-dev-ui-form-footer '] {
        position: absolute;
        bottom: -70px;
        right: 0px;
        left: 0px;
        width: 100%;
        max-width: 553px;
        margin: 0 auto;
    }

    [class^='Footer__ErrorMessage'] {
        order: 2;
        margin-top: 5px;
    }

    .dropdown-menu-enlarge {
        .syn-dev-ui-dropdown-menu {
          width: 400px;
          left: 0;
          right: -212px;
        }
      }

    .form-transaction {
        margin-left: -40px;
        width: 165%;

        [class^='LabelErrorContainer__Section'] {
            white-space: nowrap;

            &:first-child {
                margin-left: -25px;
            }
        }

        .syn-dev-ui-input {
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
        }
    }

    .form-currency {
        width: 80%;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;

        * > {
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
        }

        [class^='DropdownContent__StyledDropdownContent'] {
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
        }

        .syn-dev-ui-dropdown-head {
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
        }

        .syn-dev-ui-dropdown-input {
            height: 38px;
        }

        .syn-dev-ui-first-menu-item {
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
        }
    }
`;